module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/indi-store/pos-setup/store-pos-setup.component.css
// module id = ./src/app/indi-store/pos-setup/store-pos-setup.component.css
// module chunks = main